<script setup lang="ts">
import TechnoFrame from "@/components/Common/TechnoFrame.vue";
import GameItemsPreview from "@/components/MainPage/PcVersion/GameItemsPreview.vue";
import PreorderInfo from "@/components/MainPage/PcVersion/PreorderInfo.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'ContentHolder',

    data() {
        return {
        }
    },
})
</script>

<template>
    <div class="contentBox">
        <TechnoFrame
            :offset="5"
            :size-modifier="0.3"
        />

        <div class="contentHolder">
            <GameItemsPreview/>
            <PreorderInfo/>
        </div>
    </div>
</template>

<style scoped lang="scss">
.contentBox {
    position: relative;
    width: 1000px;
    background: rgba(15, 15, 15, 0.85);
    background-image: v-bind('`url("/img/page/landing/main/bg/2.webp")`');
    background-size: cover;
    background-position: bottom center;
    border-radius: 20px 20px 50px 50px;
    box-shadow: 0 0 20px 5px rgba(20, 20, 20, 1.0);
}

.contentHolder {
    width: 100%;
    padding: 30px 25px 45px 25px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    gap: 30px;
}

.content {
    padding: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 30px;
    //background: rgba(255, 255, 255, 0.01);
    //border: 1px solid rgba(255, 255, 255, 0.1);
    //border-radius: 10px;
    //box-shadow: inset 0 0 15px 3px rgba(255, 255, 255, 0.03);
}

.column {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
</style>
